import { ApiClient } from "@/shared/services/api-client";
import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { 
  Get2SAGetRequestModel,
  Get2SAGetResponseModel,
  Update2SAPutRequestModel,
  Update2SAPutResponseModel,
  Generate2SACodePostRequestModel,
  Generate2SACodePostResponseModel,
  Verify2SACodePostRequestModel,
  Verify2SACodePostResponseModel,
  Verify2SAReleaseCodePostRequestModel,
  Verify2SAReleaseCodePostResponseModel,
} from "@/features/two-step-authentication/services/two-step-authentication-model";

export class TwoStepAuthApi {
  /**
 * 2段階認証情報取得API
 */
  public getTwoStepAuth = async (
    params: Get2SAGetRequestModel
  ): Promise<Get2SAGetResponseModel> => {
    const path = `/api/authentication`
    
    const res = await ApiClient.instance.get<Get2SAGetResponseModel>({
      path: path,
      params: params as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };

  /**
 * 2段階認証情報更新API
 */
  public putUpdateTwoStepAuth = async (
    params: Update2SAPutRequestModel
  ): Promise<Update2SAPutResponseModel> => {
    const path = `/api/authentication`

    const res = await ApiClient.instance.put<Update2SAPutResponseModel>({
      path: path,
      params: params as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };

  /**
 * 2段階認証コード発行API
 */
  public postGenerateTwoStepAuthCode = async (
    params: Generate2SACodePostRequestModel
  ): Promise<Generate2SACodePostResponseModel> => {
    const path = `/api/authentication/code/generate`

    const res = await ApiClient.instance.post<Generate2SACodePostResponseModel>({
      path: path,
      params: params as NonNullable<unknown>,
    });
    
    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }
    return res.body;
  };
  
  /**
 * 2段階認証コード検証API
 */
  public postVerifyTwoStepAuthCode = async (
    params: Verify2SACodePostRequestModel
  ): Promise<Verify2SACodePostResponseModel> => {
    const path = `/api/authentication/code/verify`

    const res = await ApiClient.instance.post<Verify2SACodePostResponseModel>({
      path: path,
      params: params as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };

  /**
 * 2段階認証解除コード検証API
 */
  public postVerifyTwoStepAuthReleaseCode = async (
    params: Verify2SAReleaseCodePostRequestModel
  ): Promise<Verify2SAReleaseCodePostResponseModel> => {
    const path = `/api/authentication/releasecode/verify`

    const res = await ApiClient.instance.post<Verify2SAReleaseCodePostResponseModel>({
      path: path,
      params: params as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}